export type FormContentProps = Readonly<{
  children: React.JSX.Element | React.JSX.Element[];
  label: string;
  onClick?: () => void | Promise<void>;
  required?: boolean;
  requiredText?: string;
  anchorKey?: string;
  anchorCode?: string;
  className?: string;
}>;

const style = {
  layout: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '0.5rem',
  },
  labelArea: {
    color: '#888888',
    fontSize: '1.2rem',
  },
  required: {
    marginLeft: '0.5rem',
    color: '#ff0000',
  },
};

const FormContent = (props: FormContentProps) => {
  const anchorKey = props.anchorCode && (
    props.anchorKey === 'id' ? 'id' : `data-${props.anchorKey || 'index'}`
  );

  return (
    <div
      css={style.layout}
      className={props.className}
      {...(anchorKey ? { [anchorKey]: props.anchorCode } : {})}
    >
      <div css={style.labelArea} onClick={props.onClick}>
        {props.label}
        {props.required && (
          <span css={style.required}>{props.requiredText || '※必須'}</span>
        )}
      </div>
      {props.children}
    </div>
  );
};

export default FormContent;
